<template>
  <div class="relative">
    <VueLoading :active.sync="loading" :is-full-page="false" />
    <StatCard
      title="Deployments"
      :value="currentDeployments"
      :change="changePercentage"
      :isPositive="isPositive"
      customClass="deployments-stat-card"
    />
  </div>
</template>

<script>
import StatCard from './StatCard.vue'
import HTTP from '@/common/http'
import { mapGetters } from 'vuex'
import VueLoading from 'vue-loading-overlay'

export default {
  name: 'DeploymentsStatCard',
  components: { StatCard, VueLoading },
  props: {
    id: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      deployments: [],
      report: {},
      date: null,
      loading: false,
      previousDeployments: 19,
      currentDeployments: 0,
      changePercentage: 0,
      isPositive: true
    }
  },
  computed: {
    ...mapGetters(['activeType']),
    formattedDeployments () {
      return this.deployments.map(deployment => ({
        ...deployment,
        stack_name: this.getResourceName(deployment.Resources)
      }))
    }
  },
  watch: {
    deployments: {
      handler (newDeployments) {
        this.currentDeployments = newDeployments.length
        const change = this.calculateChangePercentage(this.previousDeployments, this.currentDeployments)
        this.changePercentage = change.change
        this.isPositive = change.isPositive
      },
      immediate: true
    }
  },
  created () {
    this.getMetrics(true).then(() => {
      this.getDeployments(true, this.date)
    })
  },
  destroyed () {
    clearInterval(this.interval)
  },
  methods: {
    getResourceName (resources) {
      return (resources && resources.length > 0) ? resources[0].ResourceName : ''
    },
    getDeployments (showLoading, date) {
      this.loading = showLoading
      HTTP.get(`ciinabox/summary/${this.activeType}/${this.id}/${date}`)
        .then(response => {
          this.report = response.data
          this.deployments = response.data.deployments || []
        })
        .catch(error => {
          this.deployments = []
          const msg = (error.response && error.response.data && error.response.data.error) || error.message
          if (this.flashMessage && typeof this.flashMessage.error === 'function') {
            this.flashMessage.error({
              message: `Failed to get deployments: ${msg}`
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateMetric (event) {
      if (event.eventType === 'date') {
        this.date = event.data.date
        this.getDeployments(true, this.date)
      }
    },
    updateContract (contract) {
      this.$store.dispatch('SET_ACTIVE', contract)
    },
    calculateChangePercentage (previous, current) {
      if (!previous || previous === 0) return { change: 0, isPositive: true }
      const diff = current - previous
      const change = Math.abs((diff / previous) * 100).toFixed(1)
      return {
        change,
        isPositive: diff >= 0
      }
    },
    getMetrics (showLoading) {
      this.loading = showLoading
      return HTTP.get(`/ciinabox/metrics/${this.activeType}/${this.id}/month`)
        .then(response => {
          this.metrics = response.data['metrics'] || []
          this.date = this.metrics.length > 0 ? this.metrics[11]['date'] : null
        })
        .catch(error => {
          this.metrics = []
          const msg = (error.response && error.response.data && error.response.data.error) || error.message
          if (this.flashMessage && typeof this.flashMessage.error === 'function') {
            this.flashMessage.error({
              message: `Failed to get deployments metrics: ${msg}`
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cards/StatCards/DeploymentsStatCard.vue